<div>
  <div class="grid-cont grid-cont--lg">
    <div class="grid-row grid-row--aic">
      <div class="grid-col grid-col--auto">
        <h1>Payment Settings</h1>
      </div>
    </div>

    <app-general></app-general>

    <app-auto-pay-settings
      *ngIf="configService.autoPayEnabled && configService.paymentsV4Enabled"
      [paymentPlanUis]="paymentPlanService.dataSourcePaymentPlans.data"
    ></app-auto-pay-settings>

    <app-payment-plans [paymentPlanUis]="paymentPlanService.dataSourcePaymentPlans.data"></app-payment-plans>

    <app-saved-payment-methods></app-saved-payment-methods>

    <app-client-portal-footer class="mt-4"></app-client-portal-footer>
  </div>
</div>
